import React from "react";
import { Table } from "reactstrap";

const DecisionTable = ({ data }) => {
    if (!data) return null;

    const { headers, rows, styles } = data;

    return (
        <div className="table-responsive mb-4">
            <Table bordered className="mb-0" style={{
                borderColor: styles?.borderColor || "#e6c768"
            }}>
                <thead>
                    <tr>
                        {headers?.map((header, i) => (
                            <th
                                key={i}
                                style={{
                                    backgroundColor: styles?.headerBg || "#d97706",
                                    color: styles?.headerText || "#fff",
                                    fontWeight: "700"
                                }}
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows?.map((row, index) => (
                        <tr
                            key={index}
                        >
                            {/* Index */}
                            <td className="text-center" style={{ fontWeight: "600", width: "60px", backgroundColor: styles?.rowBg || "#f9f9f9" }}>
                                {row.id}
                            </td>

                            {/* Goal */}
                            <td style={{ backgroundColor: styles?.rowBg || "#f9f9f9" }}>{row.goal}</td>

                            {/* Solution */}
                            <td style={{ fontWeight: "600", backgroundColor: styles?.rowBg || "#f9f9f9" }}>
                                {row.solution}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default DecisionTable;